import { useState, useCallback } from "react";
import { Download, FileText, CheckCircle, Loader } from "lucide-react";
import { frmsApi } from "@/api";
import { exportMarketingBrochure } from "@/utils/exportUtils";

export default function MarketingBrochure() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleExport = useCallback(async () => {
    setLoading(true);
    setDone(false);
    try {
      const r = await frmsApi.getMarketingData();
      exportMarketingBrochure(r.data || r);
      setDone(true);
      setTimeout(() => setDone(false), 5000);
    } catch (e) {
      console.error("Brochure export failed:", e);
    }
    setLoading(false);
  }, []);

  return (
    <div className="p-6" data-testid="marketing-brochure-page">
      <div className="max-w-xl mx-auto mt-20 text-center space-y-6">
        <div className="w-16 h-16 rounded-sm bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto">
          <FileText size={28} className="text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-black text-foreground">Platform Capability Brochure</h1>
          <p className="text-sm text-muted-foreground mt-2">
            5-page professional PDF covering all 19 modules, 6 integrations,<br />
            compliance standards, fleet stats, and FRMS Phase 3 highlights.
          </p>
        </div>
        <button onClick={handleExport} disabled={loading}
          className="flex items-center gap-2 mx-auto px-6 py-3 bg-primary text-primary-foreground text-sm font-bold rounded-sm hover:bg-primary/90 transition-colors disabled:opacity-50"
          data-testid="download-brochure-btn">
          {loading ? <Loader size={14} className="animate-spin" /> : done ? <CheckCircle size={14} /> : <Download size={14} />}
          {loading ? "Generating PDF..." : done ? "Downloaded!" : "Download Brochure PDF"}
        </button>
        {done && <p className="text-xs text-green-400">fatigue-shield-brochure-{new Date().toISOString().slice(0,10)}.pdf saved</p>}
        <div className="text-[11px] text-muted-foreground bg-card border border-border rounded-sm p-3">
          Includes: Cover · Module Capabilities (19) · Integration Ecosystem (6) · Compliance Standards · Fleet & Crew Stats · FRMS Phase 3
        </div>
      </div>
    </div>
  );
}
